import React from 'react';
import { Trans } from 'react-i18next';
import i18n from 'i18n';
import Tip from 'components/Common/Template/Tip';
import PopupDepartment from './PopupDepartment';

export const TabDepartment = () => {
  return (
    <>
      <div className="content">
        <div className="tab img-area department" />
        <div className="left-wrap">
          <div className="wrapper">
            <div className="large-title">
              <Trans i18nKey="BTY_W_T_ADD_DEPT_T" />
            </div>
          </div>
          <div className="large-text">
            <Trans i18nKey="BTY_W_T_ADD_DEPT_LIMIT_20" />
            <div>{i18n.t('BTY_W_T_DEPT_SORT')}</div>
            <div>
              <Trans i18nKey="BTY_W_T_DEPT_LIM" />
            </div>
          </div>
          <div className="info">
            <i className="ic-info-solid-gray sm" />
            <p className="sub-text">{i18n.t('BTY_W_T_DEPT_NOT_DEL')}</p>
          </div>
        </div>
      </div>
      <Tip subText=<Trans i18nKey="BTY_W_T_DEPT_INFO_MEM" /> />
      <PopupDepartment />
    </>
  );
};

export default TabDepartment;
